import { Drawer as MuiDrawer } from "@mui/material";
import { Heading } from "./typography";
import { IconX } from "@tabler/icons-react";
type DrawerProps = {
    open: boolean;
    close: () => void;
    content: React.ReactNode;
    title: string;
    width?: number;
};
export function Drawer({ open, close, content, title, width = 400 }: DrawerProps) {
    return (<MuiDrawer
      anchor="right"
      open={open}
      onClose={close}
      slotProps={{
        paper: {
          sx: { width, maxWidth: '100vw', backgroundColor: '#FCFCFC', backgroundImage: 'none' },
        },
      }}
    >
      <div className="flex h-full flex-col">
        <div className="flex shrink-0 items-center justify-between border-b border-borderDefault px-6 py-5">
          <Heading variant="h2" tone="dark">
            {title}
          </Heading>
          <button onClick={close} className="flex size-9 items-center justify-center rounded-lg text-textMuted transition-colors hover:bg-bgLight" aria-label="Close drawer">
            <IconX size={20}/>
          </button>
        </div>
        <div className="flex min-h-0 flex-1 flex-col">{content}</div>
      </div>
    </MuiDrawer>);
}
